import intl from 'react-intl-universal';
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ImportantOrderType } from '@/type/components';
import { useModel } from '@umijs/max';
import { Row, Col, Radio, Select, Cascader } from 'antd';
import { useState, useMemo, useEffect } from 'react';

type ImportantOrderProps = {
    value?: ImportantOrderType;
    onChange?: (value: ImportantOrderType) => void;
    disable?: boolean;
    readonly?: boolean;
};

const ImportantOrder: React.FC<ImportantOrderProps> = ({
    value,
    onChange,
    readonly,
}) => {
    const { workOrderEnums: enums } = useModel('global');
    const [publicSentimentInfoDelete, setIsDelete] = useState(
        value?.publicSentimentInfoDelete || 2,
    );
    const [importComplainGroupDealResult, setDealResult] = useState(
        value?.importComplainGroupDealResult,
    );
    const [responsible, setIsDuty] = useState(value?.responsible || 2);
    const [dutyDeptAndReason, setDeptReason] = useState(
        value?.dutyDeptAndReason,
    );

    const result: ImportantOrderType = useMemo(() => {
        if (responsible) {
            return {
                publicSentimentInfoDelete,
                importComplainGroupDealResult,
                responsible,
                dutyDeptAndReason,
            };
        } else {
            return {
                publicSentimentInfoDelete,
                importComplainGroupDealResult,
                responsible,
            };
        }
    }, [
        publicSentimentInfoDelete,
        importComplainGroupDealResult,
        responsible,
        dutyDeptAndReason,
    ]);

    useEffect(() => {
        onChange && onChange(result);
    }, [result]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                marginTop: '5px',
            }}
        >
            <Row
                gutter={10}
                align="middle"
            >
                <Col>{intl.get('舆情帖子是否删除:')}</Col>
                <Col>
                    <Radio.Group
                        onChange={({ target: { value } }) => setIsDelete(value)}
                        value={publicSentimentInfoDelete}
                        disabled={readonly}
                    >
                        <Radio value={1}>{intl.get('是')}</Radio>
                        <Radio value={2}>{intl.get('否')}</Radio>
                    </Radio.Group>
                </Col>
            </Row>

            <Row
                gutter={10}
                align="middle"
            >
                <Col>{intl.get('重大投诉处理结果:')}</Col>
                <Col>
                    <Select
                        style={{ width: 150 }}
                        showSearch
                        value={importComplainGroupDealResult}
                        onChange={setDealResult}
                        options={enums.importComplainGroupDealResultEnum}
                        disabled={readonly}
                        fieldNames={{
                            label: 'selectLabel',
                            value: 'selectValue',
                        }}
                    />
                </Col>
            </Row>

            <Row
                gutter={10}
                align="middle"
            >
                <Col>{intl.get('是否有责任:')}</Col>
                <Col>
                    <Radio.Group
                        onChange={({ target: { value } }) => setIsDuty(value)}
                        value={responsible}
                        disabled={readonly}
                    >
                        <Radio value={1}>{intl.get('是')}</Radio>
                        <Radio value={2}>{intl.get('否')}</Radio>
                    </Radio.Group>
                </Col>
            </Row>

            {responsible === 1 ? (
                <>
                    <Row
                        gutter={10}
                        align="middle"
                    >
                        <Col>{intl.get('责任部门和原因:')}</Col>
                        <Col>
                            <Cascader
                                style={{ width: 200 }}
                                showSearch
                                allowClear={false}
                                value={dutyDeptAndReason}
                                onChange={setDeptReason}
                                options={enums.publicSentimentDutyDept}
                                fieldNames={{
                                    label: 'selectLabel',
                                    value: 'selectValue',
                                }}
                                disabled={readonly}
                            />
                        </Col>
                    </Row>
                </>
            ) : null}
        </div>
    );
};

export default ImportantOrder;
